import { render } from "./yearNavigator.vue?vue&type=template&id=42269790&ts=true"
import script from "./yearNavigator.vue?vue&type=script&lang=ts"
export * from "./yearNavigator.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__